import React from 'react'
import PropTypes from "prop-types"

import { bindActionCreators } from 'redux'
import { connect } from "react-redux"

import {
  infoButtonClicked,
  toggleFilterMenu,
  setFabricPreview,
  applyFilter,
  clearFilter
} from "../../actions/ui";
import { getDesignIdShirt } from '../../actions/general';
import { 
  onFabricChanged, 
  onDetailChanged, 
  cleanContrasts,
} from "../../actions/render";
import { setBuilderPage, initSearch } from "../../actions/fabric";

import {
  isFabricInfoOpened,
  isFilterMenuOpened,
  getBuilderPage,
  getSelectefFabricPreview,
} from "../../selectors/entities/ui";
import {
  getActiveFabricFilter,
  getFiltersCount,
  getAvailableHexColorsExtended,
  getAvailableStylesColorsExtended,
  getAvailableTextColorsExtended,
  getFabricDataWithFiltersAndSearch,
  getAvailablePatternsExtended,
  getAvailableWeavesExtended,
} from '../../selectors/entities/filters';
import { getSelectedFabricValues } from '../../selectors/entities/general';

import { Popup } from "../ui/Popup"

import FabricInfo from '../FabricInfo/FabricInfo'
import FabricFooter from '../FabricFooter'
import FabricBody from '../FabricBody'
import FabricHeader from "../FabricHeader";
import FabricFilters from '../FabricFilters';
import BuilderSidePreview from '../BuilderSidePreview'

const stylesForMobilePopup = {
  margin: '30px 16px 0',
  padding: '0',
}

class BuilderFabric extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      currentFabric: null,
    };
  }

  toggleDetailModal = () => {
    this.setState({
      currentFabric: this.props.selectedFabric,
    })
    this.props.actions.infoButtonClicked(!this.props.fabricInfoOpened)
  }

  toggleInfoPopup = () => {
    this.setState({
      currentFabric: this.props.fabricPreview,
    })
    this.props.actions.infoButtonClicked(!this.props.fabricInfoOpened)
  }

  handleFabricHoverIn = (fabric) => {
    this.props.actions.setFabricPreview(fabric);
  }

  handleFabricHoverOut = () => {
    this.props.actions.setFabricPreview(false);
  }

  handleToggleFilterMenu = async () => {
    await this.props.actions.toggleFilterMenu()
  }

  handleFabricChange = (args) => {
    this.props.actions.onFabricChanged(args);
    // Сбросить контрасты
    this.props.actions.cleanContrasts();
    //сбросить монограмму Nataliia Melnikova, [29.03.21 15:36] надо вернуть обратно ( не правильно получается в использование
    //this.props.actions.onDetailChanged(false, 'printProductNumber', true, true);
  }

  handleFabricSearch = (query) => {
    this.props.actions.initSearch(query)
  }

  handleFilterChange = (filterType, filterValue, checked) => {
    this.props.actions.applyFilter(filterType, filterValue, checked)
  }

  handleFilterClear = (filterType) => {
    this.props.actions.clearFilter(filterType)
  }

  async componentWillUnmount() {
    await this.props.actions.getDesignIdShirt()
  }

  getSelectedFabricPreview = () => {
    const { selectedFabric, fabricPreview } = this.props;
    return fabricPreview || selectedFabric;
  }

  componentWillUnmount = () => {
    this.props.actions.initSearch(null);
  }

  shouldComponentUpdate = (nextProps, nextState) => {

    return (
      nextProps.fabricEnums.length !== this.props.fabricEnums.length ||
      nextProps.selectedFabric !== this.props.selectedFabric ||
      nextProps.fabricPreview !== this.props.fabricPreview ||
      nextProps.activeFabricFilters !== this.props.activeFabricFilters ||
      nextProps.fabricInfoOpened !== this.props.fabricInfoOpened ||
      nextProps.filterMenuOpened !== this.props.filterMenuOpened ||
      nextProps.filtersCount !== this.props.filtersCount ||
      nextProps.isMobile !== this.props.isMobile ||
      nextState.isShowSidePreview !== this.state.isShowSidePreview
    );
  }

  render() {

    const {
      selectedFabric,
      fabricEnums,
      builderPage,
      filterMenuOpened,
      activeFabricFilters,
      colorsHex,
      colorText,
      stylesText,
      filtersCount,
      fabricInfoOpened,
      patternsText,
      weavesText,
      isMobile,
    } = this.props;

    if (isMobile && (filterMenuOpened || fabricInfoOpened)) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    const previewOrSelectedFabric = this.getSelectedFabricPreview();

    return (
      <div
        className='b-builder-fabric'
      >
        <FabricFilters
          isOpened={filterMenuOpened}
          activeFabricFilters={activeFabricFilters}
          availableColorsText={colorText}
          availableColorsHex={colorsHex}
          availableStylesText={stylesText}
          availablePatternsText={patternsText}
          availableWeavesText={weavesText}
          isMobile={isMobile}
          onFilterChange={this.handleFilterChange}
          onFilterClear={this.handleFilterClear}
          onShowFilterClick={this.handleToggleFilterMenu}
          type='builder'
        />
        <div className='config-options-wrapper'>
          <div className='b-builder-fabric__scroll'>
            <FabricHeader
              filtersCount={filtersCount}
              filterMenuOpened={filterMenuOpened}
              isMobile={isMobile}
              onShowFilterClick={this.handleToggleFilterMenu}
              onSearch={this.handleFabricSearch}
            />
            <FabricBody
              fabricEnums={fabricEnums}
              builderPage={builderPage}
              selectedFabric={selectedFabric}
              changeFabric={this.handleFabricChange}
              toggleModal={this.toggleInfoPopup}
              selectFabric={this.handleFabricHoverIn}
              cleanFabric={this.handleFabricHoverOut}
            />
          </div>
          <FabricFooter
            isOpened={Boolean(selectedFabric)}
            isVisible={Boolean(selectedFabric)}
            isMobile={isMobile}
            onFabricInfoClicked={this.toggleDetailModal}
            {...previewOrSelectedFabric}
          />
          {isMobile && <BuilderSidePreview type='fabric' />}
        </div>
        <Popup
          closeOnEsc={true}
          isOpened={Boolean(fabricInfoOpened)}
          style={isMobile ? stylesForMobilePopup : null}
          showClose={!isMobile}
          titleClassName={'p-10 bordered bottom'}
          className={'b-fabric-info__modal-wrapper'}
          onRequestClose={this.toggleDetailModal}
        >
          <FabricInfo
            isMobile={isMobile}
            onRequestClose={this.toggleDetailModal}
            {...this.state.currentFabric}
          />
        </Popup>
      </div>
    );
  }

}


BuilderFabric.propTypes = {
  actions: PropTypes.shape({
    onFabricChanged: PropTypes.func.isRequired,
    infoButtonClicked: PropTypes.func.isRequired,
    setBuilderPage: PropTypes.func.isRequired,
    onDetailChanged: PropTypes.func.isRequired,
  }),
  fabricInfoOpened: PropTypes.bool.isRequired,
  filterMenuOpened: PropTypes.bool.isRequired,
  filtersCount: PropTypes.number.isRequired,
  activeFabricFilters: PropTypes.object.isRequired,
  selectedFabric: PropTypes.object.isRequired,
  builderPage: PropTypes.number.isRequired,
  fabricEnums: PropTypes.array.isRequired,
  colorsHex: PropTypes.array.isRequired,
  colorText: PropTypes.array.isRequired,
  stylesText: PropTypes.array.isRequired,
  fabricPreview: PropTypes.any.isRequired,
  patternsText: PropTypes.array.isRequired,
  weavesText: PropTypes.array.isRequired,
  isMobile: PropTypes.bool.isRequired,
};


function mapStateToProps(state) {

  const fabricInfoOpened = isFabricInfoOpened(state);
  const filterMenuOpened = isFilterMenuOpened(state);
  const builderPage = getBuilderPage(state);
  const selectedFabric = getSelectedFabricValues(state);

  const activeFabricFilters = getActiveFabricFilter(state);
  const colorsHex = getAvailableHexColorsExtended(state);
  const colorText = getAvailableTextColorsExtended(state);
  const stylesText = getAvailableStylesColorsExtended(state);
  const patternsText = getAvailablePatternsExtended(state);
  const weavesText = getAvailableWeavesExtended(state);

  const filtersCount = getFiltersCount(state);
  const fabricEnums = getFabricDataWithFiltersAndSearch(state);
  const fabricPreview = getSelectefFabricPreview(state);
  const isMobile = state.ui.isMobile;

  return {
    fabricInfoOpened,
    filterMenuOpened,
    filtersCount,
    activeFabricFilters,
    selectedFabric,
    builderPage,
    fabricEnums,
    colorsHex,
    colorText,
    stylesText,
    fabricPreview,
    patternsText,
    weavesText,
    isMobile,
  };
}



function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({
      onFabricChanged,
      toggleFilterMenu,
      applyFilter,
      clearFilter,
      setFabricPreview,
      initSearch,
      infoButtonClicked,
      setBuilderPage,
      getDesignIdShirt,
      onDetailChanged,
      cleanContrasts,
    }, dispatch)
  };
}

BuilderFabric.whyDidYouRender = false;

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BuilderFabric);